import { render, staticRenderFns } from "./HistoryLogMessageModalComponent.vue?vue&type=template&id=be23ae2e&scoped=true"
import script from "./HistoryLogMessageModalComponent.vue?vue&type=script&lang=js"
export * from "./HistoryLogMessageModalComponent.vue?vue&type=script&lang=js"
import style0 from "./HistoryLogMessageModalComponent.vue?vue&type=style&index=0&id=be23ae2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be23ae2e",
  null
  
)

export default component.exports